// Should be same as the Nextjs Visualizer size.
export enum TopMostIFrameName {
	Visualizer = "Visualizer",
	ProductGallery = "ProductGallery"
}

export function createParentEventHandler(usedByFakePage: boolean = false) {
	const eventHandler = (event: MessageEvent<any>) => {
		const data = event.data;
		if (typeof data === "object") {
			if (data.hasOwnProperty("cmaction")) {
/////////////////
				console.log("Message received from the child: " + JSON.stringify(data));
//////////////
				const action = data.cmaction as string;
				const iframeName = data.iframeName as TopMostIFrameName;

				const visualizerIframe = document.getElementById(usedByFakePage ? "cm-visualizer-iframe" : "cm-visualizer-iframe") as HTMLIFrameElement; // The cms also use this id, as cms will call visualizer.
				const productGalleryIframe = document.getElementById(usedByFakePage ? "cm-visualizer-iframe" : "cm-product-gallery-iframe") as HTMLIFrameElement;

				let frame: HTMLIFrameElement;
				if (iframeName == TopMostIFrameName.Visualizer)
					frame = visualizerIframe;
				else if (iframeName == TopMostIFrameName.ProductGallery)
					frame = productGalleryIframe;
				else
					frame = visualizerIframe; // Now there is a page component invalid which use the same id as visualizerIframe, so need this fallback

				if (action == "set-iframe-height") {
					const height = data.height as number;
					const heightString = height + "px";

					if (frame.style.height != heightString)
						frame.style.height = heightString;
				}
				else if (action == "remove-iframe-height") {
					frame.style.height = null;
				}
				else if (action == "hide-iframe") {
					frame.style.display = "none";
				}
				else if (action == "set-iframe-fullscreen") {
					hideLoadingIndicator(); // The visualizer is fully loaded, can hide the loading indicator.
					setFullScreen(frame);
				}
				else if (action == "unset-iframe-fullscreen") {
					frame.classList.remove("fullscreen");
					document.body.classList.remove("no-scroll");
				}
				else if (action == "load-image") {
					const message = {
						cmaction: "load-image",
						imageId: data.imageId
					}
					visualizerIframe.contentWindow.postMessage(message, "*");
				}
				else if (action == "parse-visualizer-param") {
					const query = new URLSearchParams(window.location.search);
					const tempFile = query.get('temp-file');
					const uat = Boolean(query.get('uat'));
					const bgImgIDString = query.get('image');
					const designIDString = query.get('design');
					const hash = query.get('hash');
					if (tempFile) {
						const message = {
							cmaction: "load-tempImage",
							tempFile,
							uat
						}
						visualizerIframe.contentWindow.postMessage(message, "*");
					}
					else if (bgImgIDString) {
						const bgImgID = parseInt(bgImgIDString);
						const message = {
							cmaction: "load-image",
							imageId: bgImgID
						}
						visualizerIframe.contentWindow.postMessage(message, "*");
					}
					else if (designIDString && hash) {
						const designID = parseInt(designIDString);
						const message = {
							cmaction: "load-shared-design",
							designId: designID,
							hash
						}
						visualizerIframe.contentWindow.postMessage(message, "*");
					}
					else {
						const message = {
							cmaction: "show-trim",
						}
						visualizerIframe.contentWindow.postMessage(message, "*");
					}
				}
				else if (action == "goto-oodle") {
					const location = data.location;
					window.location = location;
				}
				else if (action == "get-parent-url") {
					const message = {
						cmaction: "save-parent-url",
						href: window.location.href
					}
					visualizerIframe.contentWindow.postMessage(message, "*");
				}
			}
		}
	}
	window.addEventListener('message', eventHandler);
	return eventHandler;
}

function hideLoadingIndicator() {
	const loadingIndicator = document.getElementById('cm-loading-indicator');
	if (loadingIndicator) {
		loadingIndicator.classList.remove('cm-loading-visible');
		loadingIndicator.classList.add('cm-loading-hidden');
	}
}

export function setFullScreen(frame: HTMLIFrameElement) {
	frame.classList.add("fullscreen");
	document.body.classList.add("no-scroll");
}